export class HTMLEntities {

    private static readonly entities = {
        '&Aacute;': 'Á',
        '&aacute;': 'á',
        '&Acirc;': 'Â',
        '&acirc;': 'â',
        '&acute;': '´',
        '&AElig;': 'Æ',
        '&aelig;': 'æ',
        '&Agrave;': 'À',
        '&agrave;': 'à',
        '&alefsym;': 'ℵ',
        '&Alpha;': 'Α',
        '&alpha;': 'α',
        '&amp;': '&',
        '&and;': '∧',
        '&ang;': '∠',
        '&Aring;': 'Å',
        '&aring;': 'å',
        '&asymp;': '≈',
        '&Atilde;': 'Ã',
        '&atilde;': 'ã',
        '&Auml;': 'Ä',
        '&auml;': 'ä',
        '&bdquo;': '„',
        '&Beta;': 'Β',
        '&beta;': 'β',
        '&brvbar;': '¦',
        '&bull;': '•',
        '&cap;': '∩',
        '&Ccedil;': 'Ç',
        '&ccedil;': 'ç',
        '&cedil;': '¸',
        '&cent;': '¢',
        '&Chi;': 'Χ',
        '&chi;': 'χ',
        '&circ;': 'ˆ',
        '&clubs;': '♣',
        '&cong;': '≅',
        '&copy;': '©',
        '&crarr;': '↵',
        '&cup;': '∪',
        '&curren;': '¤',
        '&dagger;': '†',
        '&Dagger;': '‡',
        '&darr;': '↓',
        '&dArr;': '⇓',
        '&deg;': '°',
        '&Delta;': 'Δ',
        '&delta;': 'δ',
        '&diams;': '♦',
        '&divide;': '÷',
        '&Eacute;': 'É',
        '&eacute;': 'é',
        '&Ecirc;': 'Ê',
        '&ecirc;': 'ê',
        '&Egrave;': 'È',
        '&egrave;': 'è',
        '&empty;': '∅',
        '&emsp;': ' ',
        '&ensp;': ' ',
        '&Epsilon;': 'Ε',
        '&epsilon;': 'ε',
        '&equiv;': '≡',
        '&Eta;': 'Η',
        '&eta;': 'η',
        '&ETH;': 'Ð',
        '&eth;': 'ð',
        '&Euml;': 'Ë',
        '&euml;': 'ë',
        '&euro;': '€',
        '&exist;': '∃',
        '&fnof;': 'ƒ',
        '&forall;': '∀',
        '&frac12;': '½',
        '&frac14;': '¼',
        '&frac34;': '¾',
        '&frasl;': '⁄',
        '&Gamma;': 'Γ',
        '&gamma;': 'γ',
        '&ge;': '≥',
        '&gt;': '>',
        '&harr;': '↔',
        '&hArr;': '⇔',
        '&hearts;': '♥',
        '&hellip;': '…',
        '&Iacute;': 'Í',
        '&iacute;': 'í',
        '&Icirc;': 'Î',
        '&icirc;': 'î',
        '&iexcl;': '¡',
        '&Igrave;': 'Ì',
        '&igrave;': 'ì',
        '&image;': 'ℑ',
        '&infin;': '∞',
        '&int;': '∫',
        '&Iota;': 'Ι',
        '&iota;': 'ι',
        '&iquest;': '¿',
        '&isin;': '∈',
        '&Iuml;': 'Ï',
        '&iuml;': 'ï',
        '&Kappa;': 'Κ',
        '&kappa;': 'κ',
        '&Lambda;': 'Λ',
        '&lambda;': 'λ',
        '&lang;': '⟨',
        '&laquo;': '«',
        '&larr;': '←',
        '&lArr;': '⇐',
        '&lceil;': '⌈',
        '&ldquo;': '“',
        '&le;': '≤',
        '&lfloor;': '⌊',
        '&lowast;': '∗',
        '&loz;': '◊',
        '&lrm;': '\u200E',
        '&lsaquo;': '‹',
        '&lsquo;': '‘',
        '&lt;': '<',
        '&macr;': '¯',
        '&mdash;': '—',
        '&micro;': 'µ',
        '&middot;': '·',
        '&minus;': '−',
        '&Mu;': 'Μ',
        '&mu;': 'μ',
        '&nabla;': '∇',
        '&nbsp;': ' ',
        '&ndash;': '–',
        '&ne;': '≠',
        '&ni;': '∋',
        '&not;': '¬',
        '&notin;': '∉',
        '&nsub;': '⊄',
        '&Ntilde;': 'Ñ',
        '&ntilde;': 'ñ',
        '&Nu;': 'Ν',
        '&nu;': 'ν',
        '&Oacute;': 'Ó',
        '&oacute;': 'ó',
        '&Ocirc;': 'Ô',
        '&ocirc;': 'ô',
        '&OElig;': 'Œ',
        '&oelig;': 'œ',
        '&Ograve;': 'Ò',
        '&ograve;': 'ò',
        '&oline;': '‾',
        '&Omega;': 'Ω',
        '&omega;': 'ω',
        '&Omicron;': 'Ο',
        '&omicron;': 'ο',
        '&oplus;': '⊕',
        '&or;': '∨',
        '&ordf;': 'ª',
        '&ordm;': 'º',
        '&Oslash;': 'Ø',
        '&oslash;': 'ø',
        '&Otilde;': 'Õ',
        '&otilde;': 'õ',
        '&otimes;': '⊗',
        '&Ouml;': 'Ö',
        '&ouml;': 'ö',
        '&para;': '¶',
        '&part;': '∂',
        '&permil;': '‰',
        '&perp;': '⊥',
        '&Phi;': 'Φ',
        '&phi;': 'φ',
        '&Pi;': 'Π',
        '&pi;': 'π',
        '&piv;': 'ϖ',
        '&plusmn;': '±',
        '&pound;': '£',
        '&Prime;': '″',
        '&prime;': '′',
        '&prod;': '∏',
        '&prop;': '∝',
        '&Psi;': 'Ψ',
        '&psi;': 'ψ',
        '&quot;': '"',
        '&radic;': '√',
        '&rang;': '⟩',
        '&raquo;': '»',
        '&rarr;': '→',
        '&rArr;': '⇒',
        '&rceil;': '⌉',
        '&rdquo;': '”',
        '&real;': 'ℜ',
        '&reg;': '®',
        '&rfloor;': '⌋',
        '&Rho;': 'Ρ',
        '&rho;': 'ρ',
        '&rlm;': '\u200F',
        '&rsaquo;': '›',
        '&rsquo;': '’',
        '&sbquo;': '‚',
        '&Scaron;': 'Š',
        '&scaron;': 'š',
        '&sdot;': '⋅',
        '&sect;': '§',
        '&shy;': '­',
        '&Sigma;': 'Σ',
        '&sigma;': 'σ',
        '&sigmaf;': 'ς',
        '&sim;': '∼',
        '&spades;': '♠',
        '&sub;': '⊂',
        '&sube;': '⊆',
        '&sum;': '∑',
        '&sup;': '⊃',
        '&sup1;': '¹',
        '&sup2;': '²',
        '&sup3;': '³',
        '&supe;': '⊇',
        '&szlig;': 'ß',
        '&Tau;': 'Τ',
        '&tau;': 'τ',
        '&there4;': '∴',
        '&Theta;': 'Θ',
        '&theta;': 'θ',
        '&thetasym;': 'ϑ',
        '&thinsp;': ' ',
        '&THORN;': 'Þ',
        '&thorn;': 'þ',
        '&tilde;': '˜',
        '&times;': '×',
        '&trade;': '™',
        '&Uacute;': 'Ú',
        '&uacute;': 'ú',
        '&uarr;': '↑',
        '&uArr;': '⇑',
        '&Ucirc;': 'Û',
        '&ucirc;': 'û',
        '&Ugrave;': 'Ù',
        '&ugrave;': 'ù',
        '&uml;': '¨',
        '&upsih;': 'ϒ',
        '&Upsilon;': 'Υ',
        '&upsilon;': 'υ',
        '&Uuml;': 'Ü',
        '&uuml;': 'ü',
        '&weierp;': '℘',
        '&Xi;': 'Ξ',
        '&xi;': 'ξ',
        '&Yacute;': 'Ý',
        '&yacute;': 'ý',
        '&yen;': '¥',
        '&Yuml;': 'Ÿ',
        '&yuml;': 'ÿ',
        '&Zeta;': 'Ζ',
        '&zeta;': 'ζ',
        '&zwj;': '\u200D',
        '&zwnj;': '\u200C',
    };
    static cache = {};
    private static decodeHtmlEntitiesToEmptySpaces(str) {
        return str.replace(/&[a-zA-Z0-9#]+;/g, match => {
            if (this.cache[match]) {
                return this.cache[match];
            } else {
                let returnValue = [];
                for (let i = 0; i < match.length; i++) {
                    returnValue.push(' ');
                }
                let finalResult = returnValue.join('')
                this.cache[match] = finalResult;
                return finalResult;
            }
        });
    }
    private static removeHtmlTags(str) {
        let cleanedText = str.replace(/<[^>]*>/g, match => ' '.repeat(match.length));
        // let charWithIndex = [];
        // for (let i = 0; i < cleanedText.length; i++) {
        //     charWithIndex.push({ char: cleanedText[i], index: i });
        // }
        return cleanedText;
    }

    static cleanuphtml(str){
        let decodedtxt = HTMLEntities.decodeHtmlEntitiesToEmptySpaces(str);
        let cleantxt = HTMLEntities.removeHtmlTags(decodedtxt);        
        return cleantxt;
    }
}
